import { parse } from 'qs'
import config from 'config'
import mixpanel from 'helpers/mixpanel'
import { isIphone } from './userAgent'
import { navigateToLibrary } from 'helpers/navigation/navigateToLibrary'

function waitForUserIdentification() {
	return Promise.race([mixpanel.waitForUserIdentification(), new Promise(resolve => {
		setTimeout(1000, resolve)
	})])
}

function navigateToWindowLocation(location) {
	waitForUserIdentification().then(function() {
		window.location.href = location
	})
}

function redirectTo(responseRedirect, userData) {
	userData = userData || {}
	const params = parse(location.search.substr(1))
	const r = new RegExp('^(?:[a-z]+:)?//', 'i')

	if (responseRedirect !== undefined && responseRedirect !== '') {
		navigateToWindowLocation(responseRedirect)
	} else if (params.referer) {
		var refererUrl = params.referer
		if (userData.new_user) {
			refererUrl += refererUrl.indexOf('?') === -1 ? '?' : '&'
			refererUrl += 'new_user=1'
		}
		if (r.test(refererUrl)) {
			navigateToWindowLocation(config.ct + 'redirect.php?url=' + encodeURIComponent(refererUrl))
		} else {
			navigateToWindowLocation(refererUrl)
		}
	} else if (userData.new_user) {
		if (isIphone()) {
			navigateToWindowLocation(config.app + 'notAccessible')
		} else {
			navigateToLibrary()
		}
	} else {
		navigateToLibrary()
	}
}

const getFormattedUrl = url => {
	if (!/^[a-zA-Z]*:\/\//.test(url)) {
		url = 'http://' + url
	}
	return url
}

export default redirectTo

export {
	getFormattedUrl,
}
